import { createVanIconComponent } from "./van"

const Alipay = createVanIconComponent("alipay")
export default Alipay
